/**
 * Created by mukund on 2/24/17.
 *
 * This file has the UI router state information for the LMS Assignment Tool module
 */

'use strict';

angular.module('mediacloudApp')
    .config(function($stateProvider){
        $stateProvider
            .state('lmsAssignments', {
                parent: 'site',
                url: '/lms/assignments/:collectionId/:authToken',
                data: {
                    roles: [],
                    pageTitle: 'lms-assignments.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/lms/assignments/templates/lms-assignments.html',
                        controller: 'LMSAssignmentsController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lms-assignments');
                        return $translate.refresh();
                    }]
                }
            });
    });
